/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_No_Events_WarningInputs */



/**
* | output |
* | --- |
* | "No captions fall within the selected segment" |
*
* @param {Video_Export_Segment_No_Events_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_no_events_warning = /** @type {((inputs?: Video_Export_Segment_No_Events_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_No_Events_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune légende ne correspond au segment sélectionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Im ausgewählten Segment befinden sich keine Untertitel.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna didascalia rientra nel segmento selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В выбранный сегмент не попадают никакие подписи.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay subtítulos dentro del segmento seleccionado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所选片段内没有字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択されたセグメント内にキャプションはありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित खंड में कोई कैप्शन नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma legenda se enquadra no segmento selecionado.")
	return /** @type {LocalizedString} */ ("No captions fall within the selected segment")
});